import { defineModel } from "../define-model";

export type ArtifactKind = "text" | "image" | "video" | "audio" | "document";

export type Artifact = {
	id: string;
	workspaceId: string;
	projectId: string;
	flowId: string | null;
	flowRunId: string | null;
	nodeRunId: string | null;
	nodeId: string | null;
	kind: ArtifactKind;
	status: "pending" | "ready" | "failed";
	source: "generated" | "uploaded" | "imported";
	title: string;
	mimeType: string | null;
	r2Key: string | null;
	metadataR2Key: string | null;
	thumbnailR2Key: string | null;
	sizeBytes: number | null;
	width: number | null;
	height: number | null;
	durationMs: number | null;
	textContent: string | null;
	provider: string;
	model: string | null;
	prompt: string | null;
	params: Record<string, unknown>;
	generationId: string | null;
	usage: Record<string, unknown> | null;
	costUsd: number;
	upstreamCostUsd: number | null;
	millicredits: number;
	generation: Record<string, unknown> | null;
	tags: string[];
	createdById: string | null;
	archivedAt: string | null;
	createdAt: string;
	updatedAt: string;
};

declare module "../types" {
	interface SyncModels {
		artifact: Artifact;
	}
}

export const model = defineModel({
	name: "artifact",
	load: "lazy",
	indexes: ["projectId"],
	sort: (a, b) => b.createdAt.localeCompare(a.createdAt),
});
